import { adminStaffMutations } from '../adminStaff/adminStaff.mutations';
import { affiliateMutations } from '../affiliate/affiliate.mutations';
import { authMutations } from '../auth/auth.mutations';
import { basicStoresMutations } from '../basicStores/basicStores.mutation';
import { chargeMutations } from '../charges/charge.mutation';
import { chargeSlabMutations } from '../chargeSlab/chargeSlab.mutation';
import { commissionsMutations } from '../commissions/commissions.mutation';
import { commissionsTypeMutations } from '../commissionsType/commissionsType.mutation';
import { customerPaymentLogsMutation } from '../customerPaymentLogs/customerPaymentLogs.mutation';
import { customersMutations } from '../customers/customers.mutation';
import { reservationLedgerMutations } from '../dashboard/reservationLedger/reservationLedger.mutation';
import { discountCategoryMutations } from '../discount-management/discount-category.mutation';
import { editorsPickMutations } from '../editorsPick/editorsPick.mutation';
import { faqMutations } from '../faq/faq.mutation';
import { galleryManagementMutations } from '../galleryManagement/galleryManagement.mutation';
import { groupManagementMutations } from '../groupsManagement/groupManagement.mutation';
import { hoslogPlansRequestMutations } from '../hoslog-plans/hoslog-plans-request.mutation';
import { hoslogPlansMutations } from '../hoslog-plans/hoslog-plans.mutation';
import { hostManagementMutations } from '../hostManagement/hostManagement.mutation';
import { locationMutations } from '../locations/locations.mutations';
import { mainPageMutations } from '../mainPage/mainPage.mutations';
import { mainPageHostMutations } from '../mainPage/storeList/hostList/hostList.mutations';
import { mainPageStoreMutations } from '../mainPage/storeList/storeList.mutations';
import { paymentMutations } from '../payment/payment.mutations';
import { pointConfigurationMutations } from '../pointConfiguration/pointConfiguration.mutations';
import { lineGroupMutations } from '../premiumStores/lineGroup/lineGroup.mutation';
import { premiumStoresMutations } from '../premiumStores/premiumStores.mutation';
import { subDomainMutations } from '../premiumStores/subDomain/subDomain.mutation';
import { promotionalBannerMutations } from '../promotionalBanner/promotionalBanner.mutations';
import { privilegeMutations } from '../rolesPrivilege/privileges.mutation';
import { roleMutations } from '../rolesPrivilege/roles.mutation';
import { slabMutations } from '../slabs/slabs.mutation';
import { staticDataTypeMutations } from '../staticDataType/staticDataType.mutations';
import { tagManagementMutations } from '../tagManagement/tagManagement.mutation';
import { userProfileMutations } from '../userProfile/userProfile.mutations';
import { withdrawalsMutations } from '../withdrawals/withdrawals.mutations';
import { customerWithdrawalMutations } from '../withdrawals/customerWithdrawal.mutations';

// API_COLLECTION_IMPORTS

export const mutations = {
  ...authMutations,
  ...locationMutations,
  ...pointConfigurationMutations,
  ...roleMutations,
  ...privilegeMutations,
  ...privilegeMutations,
  ...commissionsMutations,
  ...customersMutations,
  ...chargeMutations,
  ...chargeSlabMutations,
  ...reservationLedgerMutations,
  ...discountCategoryMutations,
  ...withdrawalsMutations,
  ...slabMutations,
  ...commissionsTypeMutations,
  ...affiliateMutations,
  ...hoslogPlansMutations,
  ...hoslogPlansRequestMutations,
  ...premiumStoresMutations,
  ...hostManagementMutations,
  ...galleryManagementMutations,
  ...tagManagementMutations,
  ...basicStoresMutations,
  ...editorsPickMutations,
  ...adminStaffMutations,
  ...lineGroupMutations,
  ...subDomainMutations,
  ...groupManagementMutations,
  ...faqMutations,
  ...promotionalBannerMutations,
  ...userProfileMutations,
  ...staticDataTypeMutations,
  ...customerWithdrawalMutations,
  ...customerPaymentLogsMutation,
  ...mainPageMutations,
  ...mainPageStoreMutations,
  ...mainPageHostMutations,
  ...paymentMutations,
  // API_COLLECTION_MUTATIONS
} as const;

export type AxiosMutationsType = typeof mutations;
